import * as React from 'react';
import styled, { css } from 'styled-components';

import { AppBuilderIcon, AutoRunIcon } from '../../icons/Icons';

import { CommentButton } from './CommentButton';
import { OutlinedButton } from './SharedStyles';

export type CellHeaderStyle = 'top' | 'floating';

const CellLabel = styled.div`
  color: ${({ theme }) => theme.fontColor.DEFAULT};
  font-size: ${({ theme }) => theme.fontSize.SMALL};
  line-height: initial;
  opacity: 0.5;
`;

const CellActions = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 3px;
`;

const Header = styled.div<{ $style: CellHeaderStyle }>`
  display: flex;
  align-items: center;
  height: 24px;

  ${({ $style }) =>
    $style === 'floating' &&
    css`
      position: absolute;
      left: calc(100% + 5px);
      flex-direction: column;

      ${CellLabel} {
        display: none;
      }

      ${CellActions} {
        flex-direction: column-reverse;
      }
    `}
`;

interface CellHeaderProps {
  commentPopupOverride?: boolean;
  disabled?: boolean;
  headerStyle?: 'top' | 'floating';
  hideHeaderActions?: boolean;
  label: string;
  showCommentCount?: boolean;
}

export const CellHeader: React.ComponentType<CellHeaderProps> = React.memo(
  ({
    commentPopupOverride,
    label,
    disabled = true,
    headerStyle = 'top',
    showCommentCount = false,
    hideHeaderActions = false
  }) => {
    return (
      <Header $style={headerStyle}>
        <CellLabel>{label}</CellLabel>
        {!hideHeaderActions && (
          <CellActions>
            <CommentButton
              disabled={disabled}
              popupOverride={commentPopupOverride}
              showCommentCount={showCommentCount}
            />
            <OutlinedButton $disabled={disabled} $minimal={true} $small={true}>
              <AppBuilderIcon />
            </OutlinedButton>
            <OutlinedButton
              $active={true}
              $disabled={disabled}
              $minimal={true}
              $small={true}>
              <AutoRunIcon />
            </OutlinedButton>
          </CellActions>
        )}
      </Header>
    );
  }
);
